
import { Link } from 'react-router-dom';
import { PlusCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyAssessmentsListProps {
  searchTerm: string;
}

export function EmptyAssessmentsList({ searchTerm }: EmptyAssessmentsListProps) {
  return (
    <div className="text-center p-10">
      <h3 className="text-lg font-medium">No assessments found</h3>
      <p className="text-muted-foreground mt-2">
        {searchTerm ? "Try a different search term" : "Get started by creating a new assessment"}
      </p>
      {!searchTerm && (
        <Button asChild className="mt-4">
          <Link to="/admin/assessments/create">
            <PlusCircle className="mr-2 h-4 w-4" />
            Create Assessment
          </Link>
        </Button>
      )}
    </div>
  );
}
